const UUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

// This field is the cross-brand UE product identity on rendered listings.
// Legacy GIDs, numeric IDs, and slugs are deliberately rejected by this helper.
export const getResearchBoardProductCanonicalId = (product) => {
  const canonicalId =
    product?.product_canonical_id || product?.productCanonicalId;
  return UUID_PATTERN.test(String(canonicalId || '')) ? canonicalId : null;
};

// BX API product nodes expose their canonical product UUID as `id`. Keep the
// BX-specific fallback here so generic listing objects remain fail-closed.
export const getBxResearchBoardProductCanonicalId = (product) =>
  getResearchBoardProductCanonicalId({
    product_canonical_id:
      product?.product_canonical_id ||
      product?.productCanonicalId ||
      product?.id,
  });

export const hasResearchBoardProductCanonicalId = (product) =>
  Boolean(getResearchBoardProductCanonicalId(product));
